import React from 'react';
import { User, Award, BookOpen, Compass } from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';

export const About = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();
  const [card4Ref, card4Visible] = useScrollAnimation();

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/jvy7f39f_IMG_6781.jpeg"
              alt="Heath speaking to an audience"
              className="about-photo"
            />
          </div>

          <div className="about-content">
            <h2 
              ref={titleRef}
              className={`heading-1 animate-slide-up ${titleVisible ? 'is-visible' : ''}`}
            >
              Not Just Health… But HEATH
            </h2>
            <p className="body-large">
              After over two decades in the fitness and wellbeing industry, I've come to 
              understand something powerful — true vitality isn't built through extremes, 
              ego, or punishment.
            </p>
            <p className="body-medium">
              It's built through self-respect. Through discipline rooted in devotion. 
              Through aligning body, mind, spirit and purpose.
            </p>

            <div className="about-values">
              <div 
                ref={card1Ref}
                className={`value-card animate-on-scroll ${card1Visible ? 'is-visible' : ''}`}
              >
                <div className="value-icon">
                  <User size={28} />
                </div>
                <h3 className="heading-3">Personal Approach</h3>
                <p className="body-small">
                  Your body is either your TOMB or TEMPLE... it's a CHOICE.
                </p>
              </div>

              <div 
                ref={card2Ref}
                className={`value-card animate-on-scroll animate-delay-1 ${card2Visible ? 'is-visible' : ''}`}
              >
                <div className="value-icon">
                  <Award size={28} />
                </div>
                <h3 className="heading-3">20+ Years Experience</h3>
                <p className="body-small">
                  Two decades of proven results blending functional fitness, nervous 
                  system awareness, and mindset mastery.
                </p>
              </div>

              <div 
                ref={card3Ref}
                className={`value-card animate-on-scroll animate-delay-2 ${card3Visible ? 'is-visible' : ''}`}
              >
                <div className="value-icon">
                  <BookOpen size={28} />
                </div>
                <h3 className="heading-3">Holistic Integration</h3>
                <p className="body-small">
                  Where momentum is guided by presence. Peace is power. Mind, body, 
                  and spirit aligned.
                </p>
              </div>

              <div 
                ref={card4Ref}
                className={`value-card animate-on-scroll animate-delay-3 ${card4Visible ? 'is-visible' : ''}`}
              >
                <div className="value-icon">
                  <Compass size={28} />
                </div>
                <h3 className="heading-3">Purpose-Driven</h3>
                <p className="body-small">
                  For the man ready to lead himself. For the human ready to update 
                  who they are.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
